import React from "react"

import { cn } from "@/lib/utils"

interface StepperStepProps {
  title: string
  stage: string
  allStagesInStep?: string[] // Add optional array of all stages in this step
  currentStage: string
  completedStages: string[]
  number: number
}

const StepperStep: React.FC<StepperStepProps> = ({
  title,
  stage,
  allStagesInStep = [], // Default to empty array if not provided
  currentStage,
  completedStages,
  number,
}) => {
  // Check if this step is active (current)
  // A step is active if the current stage is either the primary stage or any of the stages in this step
  const isActive =
    currentStage === stage || (allStagesInStep.length > 0 && allStagesInStep.includes(currentStage))

  // Check if this step is completed
  const isCompleted = completedStages.includes(stage)

  return (
    <div className="flex flex-col items-center">
      <div className="flex items-center justify-center">
        <div
          className={cn(
            "flex h-6 w-6 items-center justify-center rounded-full border-2 text-xs font-medium md:h-8 md:w-8 md:text-sm",
            isActive
              ? "border-honeycomb bg-honeycomb text-white"
              : isCompleted
                ? "border-jungle bg-jungle text-white"
                : "border-gray-300 text-gray-500",
          )}
        >
          {number}
        </div>
      </div>
      <div
        className={cn(
          "mt-1 max-w-[60px] text-center text-[10px] leading-tight md:mt-2 md:max-w-none md:text-xs",
          isActive ? "text-honeycomb" : isCompleted ? "text-jungle" : "text-gray-500",
        )}
      >
        {title}
      </div>
    </div>
  )
}

export default StepperStep
